module.exports = __webpack_public_path__ + "img/PorkGermany.ff1d0bf5.png";